// Route-Utils
export { findMatchingRoutePath, getChildren, extractRouteDataFromRouterConfig, normalizeRoutePath } from './utils';

// Route-Data
export {
    RouteDataModule,
    RouteDataInterface,
    RouteDataRegistry,
    LabelFunction,
    ReadonlyRouteData,
    RouteData,
    RouteDataList,
    ROUTE_DATA
} from './data';
